export default "__VITE_ASSET__DgYugMhq__"